import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { PHONE_TEL, WHATSAPP_URL } from "../data/content";

export const StickyCTA = () => (
  <motion.div
    initial={{ y: 100, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ delay: 2, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    className="fixed bottom-5 left-1/2 -translate-x-1/2 z-50 flex items-center gap-3 p-2 rounded-full bg-[#F1EDE3]/90 backdrop-blur-xl border border-[#E3DCCB] shadow-[0_20px_60px_-15px_rgba(0,0,0,0.9)]"
    data-testid="sticky-action-bar">
    <a href={PHONE_TEL} data-testid="sticky-call-button"
      className="flex items-center gap-2 px-6 py-3 rounded-full bg-[#0B5A4E] text-[#FAF8F3] text-sm font-semibold hover:bg-[#0D6B5C] transition-colors">
      <Phone size={15} /> <span className="hidden sm:inline">Call Now</span><span className="sm:hidden">Call</span>
    </a>
    <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="sticky-whatsapp-button"
      className="flex items-center gap-2 px-6 py-3 rounded-full bg-[#25D366] text-[#FAF8F3] text-sm font-semibold hover:bg-[#1DA851] transition-colors">
      <MessageCircle size={15} /> <span className="hidden sm:inline">WhatsApp</span><span className="sm:hidden">Chat</span>
    </a>
  </motion.div>
);
